import React, { useState } from "react";
import "./Header.css";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "@coreui/coreui/dist/css/coreui.min.css";
import Menu from "./HamburgIconMobile/menu";
import Close from "./HamburgIconMobile/close";
import { disablePageScroll, enablePageScroll } from "scroll-lock";
import secureLocalStorage from "react-secure-storage";
import { useEffect } from "react";
import {
  CDropdownMenu,
  CDropdown,
  CDropdownToggle,
  CDropdownItem,
} from "@coreui/react";

import { createGlobalStyle, ThemeProvider } from "styled-components";

// Define global styles
const GlobalStyle = createGlobalStyle`
  html {
    filter: ${(props) => props.theme.htmlFilter};
  }
  
  img,
  picture,
  video {
    filter: ${(props) => props.theme.mediaFilter};
  }
  
  .logo-name {
    color: ${(props) => props.theme.logoColor};
    background-image: -webkit-linear-gradient(45deg, ${(props) =>
      props.theme.gradientStart} 15%, ${(props) =>
  props.theme.gradientEnd} 65%);
    background-clip: text;
    -webkit-background-clip: text;
    text-fill-color: transparent;
    -webkit-text-fill-color: transparent;
  }
  
  [class="footer-drak"] {
    filter: ${(props) => props.theme.footerFilter};
  }
  
  [class="sign-up-name-logo-field"] {
    filter: ${(props) => props.theme.signupFilter};
  }
  
  ::-webkit-scrollbar {
    width: auto;
    background-color: ${(props) => props.theme.scrollbarBackground};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.scrollbarThumb};
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }

  ::-webkit-scrollbar-track {
    background-color: ${(props) => props.theme.scrollbarTrack};
  }
  
  .watchlist-main-container {
    background-color: ${(props) => props.theme.watchlistBackgroundColor};
  }
`;

// Define light theme
const lightTheme = {
  htmlFilter: "none",
  mediaFilter: "none",
  logoColor: "#69a8f3",
  gradientStart: "#236dc7",
  gradientEnd: "#19b471",
  footerFilter: "none",
  signupFilter: "invert(0) hue-rotate(180deg)",
  scrollbarBackground: "#f1f1f1",
  scrollbarThumb: "#888",
  scrollbarTrack: "#f1f1f1",
  watchlistBackgroundColor: "aliceblue",
};

// Define dark theme
const darkTheme = {
  htmlFilter: "invert(1) hue-rotate(180deg)",
  mediaFilter: "invert(1) hue-rotate(180deg)",
  logoColor: "#69a8f3",
  gradientStart: "#236dc7",
  gradientEnd: "#19b471",
  footerFilter: "invert(1) hue-rotate(180deg)",
  signupFilter: "invert(0) hue-rotate(180deg)",
  scrollbarBackground: "#424242",
  scrollbarThumb: "#686868",
  scrollbarTrack: "#424242",
  watchlistBackgroundColor: "aliceblue",
};

function Header() {
  const [isChecked, setIsChecked] = useState(false);

  // function for hide side bar on mobile devices on link Click
  function onclik() {
    document.getElementById("click").checked = false;
    setIsChecked(false);
    enablePageScroll();
  }

  const handleChange = (event) => {
    if (event.target.checked) {
      setIsChecked(true);
      disablePageScroll();
    } else {
      setIsChecked(false);
      enablePageScroll();
    }
  };

  let navigate = useNavigate();
  function handleClickNavigate() {
    navigate("/");
  }

  function logout() {
    localStorage.clear();
    handleClickNavigate();
  }

  const user = secureLocalStorage.getItem("user-info");

  // automatic logout if user inactive for 1hour

  function checkUserActivity() {
    const lastActivityTime = localStorage.getItem("last-activity-time");
    const currentTime = new Date().getTime();

    if (lastActivityTime && currentTime - lastActivityTime >= 3600000) {
      localStorage.clear();
    }
  }

  function updateLastActivityTime() {
    const currentTime = new Date().getTime();
    localStorage.setItem("last-activity-time", currentTime);
  }

  document.addEventListener("mousemove", () => {
    const userInfo = localStorage.getItem("@secure.j.user-info");
    if (userInfo) {
      updateLastActivityTime();
    }
  });

  document.addEventListener("keydown", () => {
    const userInfo = localStorage.getItem("@secure.j.user-info");
    if (userInfo) {
      updateLastActivityTime();
    }
  });

  const userInfo = localStorage.getItem("@secure.j.user-info");
  if (userInfo) {
    setInterval(checkUserActivity, 60000);
  }

  // switch between dark n light mode
  const [isDarkMode, setIsDarkMode] = useState(false);

  const handleToggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };
  // end switch between dark n light mode

  return (
    <div>
      <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
        <GlobalStyle />
        <nav className="shift">
          <NavLink to="/">
            <div className="logo-container">
              <div className="logo-name">Coinwatchers</div>
            </div>
          </NavLink>
          <div className="dark-mode-toggle-div-mobile">
              <label className="switch">
                <span className="sun">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <g fill="#ffd43b">
                      <circle r="5" cy="12" cx="12"></circle>
                      <path d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"></path>
                    </g>
                  </svg>
                </span>
                <span className="moon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                    <path d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"></path>
                  </svg>
                </span>
                <input
                  type="checkbox"
                  value={isDarkMode}
                  onChange={handleToggleTheme}
                  className="input"
                />
                <span className="slider"></span>
              </label>
            </div>  
          <input
            type="checkbox"
            value={isChecked}
            onChange={handleChange}
            id="click"
            name="click"
            CloseOnDocumentClick="true"
          />
          <label htmlFor="click" className="menu-btn">
            <i> {isChecked === true ? <Close /> : <Menu />} </i>
          </label>

          <ul className="ul">
            <li>
             <div className="dark-mode-toggle-div">
              <label className="switch">
                <span className="sun">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <g fill="#ffd43b">
                      <circle r="5" cy="12" cx="12"></circle>
                      <path d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"></path>
                    </g>
                  </svg>
                </span>
                <span className="moon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                    <path d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"></path>
                  </svg>
                </span>
                <input
                  type="checkbox"
                  value={isDarkMode}
                  onChange={handleToggleTheme}
                  className="input"
                />
                <span className="slider"></span>
              </label>
            </div>  
            </li>
            <li className="home-sidebar">
              <NavLink to="/" className="a" onClick={onclik}>
                HOME
              </NavLink>
            </li>
            <li>
              <NavLink to="/news" className="a" onClick={onclik}>
                NEWS
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className="a" onClick={onclik}>
                ABOUT
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="a" onClick={onclik}>
                CONTACT
              </NavLink>
            </li>
            <li>
              {secureLocalStorage.getItem("user-info") ? (
                <div>
                  <CDropdown>
                    <CDropdownToggle color="primary">
                      <span className="after-login-name">
                        &nbsp; Hi, {user.username.split(" ")[0]} &nbsp;
                      </span>
                    </CDropdownToggle>
                    <CDropdownMenu>
                      <NavLink
                        to="/user-profile"
                        className="login-userprofile-navlink"
                        onClick={onclik}
                      >
                        <CDropdownItem>Profile</CDropdownItem>
                      </NavLink>
                      <NavLink
                        to="/user/watchlist"
                        className="login-userprofile-navlink"
                        onClick={onclik}
                      >
                        <CDropdownItem>WatchList</CDropdownItem>
                      </NavLink>
                      <CDropdownItem onClick={logout} href="/">
                        Logout
                      </CDropdownItem>
                    </CDropdownMenu>
                  </CDropdown>
                </div>
              ) : (
                <NavLink to="/sign-in" className="sign-in-btn" onClick={onclik}>
                  SIGN IN
                </NavLink>
              )}
            </li>
          </ul>
        </nav>
      </ThemeProvider>
    </div>
  );
}

export default Header;
